import { useSelector } from 'react-redux'

export const useBranding = () => {
  const { branding } = useSelector(state => state.properties);

  return [branding];
};
